import PageList from '#/modules/commonComponents/PageList';
import productionNavigate from '#/modules/infra/navigation/productionNavigate';

const ProductionHubPage = () => (
  <PageList title="生產製造" linkList={productionNavigate} />
);

export default ProductionHubPage;

